<div>
  @if (!partRow && canCreateCase) {
    <button
      class="btn btn-sm btn-default-orange pull-right mb-3"
      (click)="routeToNewCase()"
      [title]="app.text.thread.create"
      >
      <i class="far fa-folder-plus pointer"></i>&nbsp;
      {{ app.text.app.add }}
    </button>
  }
</div>
<div class="tableFixHead clear">
  <table class="table spacing-table table-striped">
    <thead>
      <!-- <th class="text-center" *ngFor="let field of app.list.thread.boxesOnListOfOpenedCases">{{ app.field.getLabel("part.partNumber") }} {{field}}</th> -->
      @for (field of app.list.thread.boxesOnListOfOpenedCases; track field) {
        <th
          class="text-center"
          >
          <!-- {{ app.field.getLabel(field) }} -->
          {{ app.field.getTableLabel(field) }}
        </th>
      }
    </thead>
    <tbody>
      @for (thread of app.thread.threadsByPartNumber; track thread) {
        <tr class="pointer">
          @for (column of columns; track column) {
            <td class="text-center">
              <span>
                @if (column !== 'omfStatus') {
                  <a
                    (click)="routeToThreadDetails(thread._id)"
                    >
                    {{ thread[column] }}
                  </a>
                }
                @if (column === 'omfStatus') {
                  <a>
                    {{ app.field.getOptionText("thread." + column, thread[column]) }}
                  </a>
                }
              </span>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
